<div
[style.background-color]="tipo  === 'danger' ? 'rgb(255 194 194 / 20%)' : (tipo  === 'info' ? 'rgb(178 197 225 / 20%)' : (tipo  === 'success' ? 'rgb(191 230 187 / 20%)' : null))"
 id="id-alert-{{id}}"
  [ngClass]="{'border-info': tipo === 'info', 'border-danger' : tipo === 'danger', 'border-success' : tipo === 'success' }"
  class="row alert border rounded my-2" role="alert">
  <div class="col- mt-0">
    <i *ngIf="tipo == 'success'" style="color: #4ba942;" class="fa fa-check" aria-hidden="true"></i>
    <i *ngIf="tipo == 'info'" style="color: #426da9;" class="fa fa-info-circle" aria-hidden="true"></i>
    <i *ngIf="tipo == 'danger'" class="fa fa-exclamation-circle" aria-hidden="true" style="color:red"></i>
  </div>
  <div class="col">

    <strong style="font-size: 14px;"
      [style.color]="tipo  === 'danger' ? '#e4002b' : (tipo  === 'info' ? '#426da9' : (tipo  === 'success' ? '#0c6503' : null))">{{titulo}}</strong>
    <ng-content></ng-content>

  </div>

</div>
